var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38597 6.38589L0.931632 11.8402C0.880956 11.8908 0.820794 11.931 0.754582 11.9585C0.68837 11.9859 0.617405 12 0.545737 12C0.47407 12 0.403105 11.9859 0.336893 11.9585C0.270681 11.931 0.210519 11.8908 0.159842 11.8402C0.109166 11.7895 0.0689674 11.7293 0.0415415 11.6631C0.0141157 11.5969 0 11.5259 0 11.4543C0 11.3826 0.0141157 11.3116 0.0415415 11.2454C0.0689674 11.1792 0.109166 11.1191 0.159842 11.0684L5.22897 6L0.159842 0.93162C0.0574969 0.829275 -1.07839e-09 0.690467 0 0.54573C1.07839e-09 0.400994 0.0574969 0.262185 0.159842 0.159841C0.262188 0.0574964 0.400999 1.07837e-09 0.545737 0C0.690476 -1.07837e-09 0.829287 0.0574964 0.931632 0.159841L6.38597 5.61411C6.43669 5.66476 6.47692 5.72492 6.50437 5.79113C6.53181 5.85735 6.54594 5.92832 6.54594 6C6.54594 6.07168 6.53181 6.14265 6.50437 6.20887C6.47692 6.27508 6.43669 6.33523 6.38597 6.38589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSee);
export default __webpack_public_path__ + "static/media/see.897eda1809eea05830c77c5977a085f7.svg";
export { ForwardRef as ReactComponent };